<template src="./markasbeingrepaired.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
export default {
  props: ["NewTrailer"],
  methods: {
    RepairTrailer(trailer_id, type) {
      var vehicleType = type == "Trailer" ? "Trailer" : "Vehicle";
      this.$swal
        .fire({
          title: "Being Repaired",
          text:
            "You are about to mark this " +
            vehicleType +
            " as being repaired by your garage",
          //icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Continue",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Processing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Vehicle.BeingRepaired, {
              token: localStorage.getItem("token"),
              vehicle_id: trailer_id,
            }).then((Response) => {
              if (Response.data.success == true) {
                this.NewTrailer.being_repaired = 1;
                this.$swal
                  .fire(
                    vehicleType + " Mark as Being Repaired Successfully",
                    "",
                    "success"
                  )
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response.data.message, "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    RepairCompleteTrailer(trailer_id, type) {
      var vehicleType = type == "Trailer" ? "Trailer" : "Vehicle";
      this.$swal
        .fire({
          title: "Repairing Completed",
          text:
            "You are about to mark this " +
            vehicleType +
            " as repairing Completed by your garage",
          //icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Continue",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Processing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Vehicle.CompleteRepairing, {
              token: localStorage.getItem("token"),
              vehicle_id: trailer_id,
            }).then((Response) => {
              if (Response.data.success == true) {
                this.NewTrailer.being_repaired = 0;
                this.$swal
                  .fire(
                    vehicleType + " Mark as Repairing Completed",
                    "",
                    "success"
                  )
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response.data.message, "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
  },
};
</script>
